"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_ratings_declarative_1 = __importDefault(require("react-ratings-declarative"));
var CalculatorContextInterface_1 = require("../../CalculatorContextInterface");
var GameRating = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var game = (0, CalculatorContextInterface_1.useCalculatorContext)().game;
    var _b = (0, react_1.useState)(), gameId = _b[0], setGameId = _b[1];
    var MAX_RATING = 5;
    var _c = (0, react_1.useState)(), rating = _c[0], setRating = _c[1];
    (0, react_1.useEffect)(function () {
        if (game) {
            setGameId(game.id);
        }
    }, [game]);
    (0, react_1.useEffect)(function () {
        if (gameId) {
            handleLoadRating(gameId);
        }
    }, [gameId]);
    (0, react_1.useEffect)(function () {
        if (props.flagOutside) {
            var formNode = document.getElementById("react-game-not-active-stars");
            var gameId_1 = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-id');
            if (gameId_1) {
                setGameId(parseInt(gameId_1));
            }
        }
    }, [props]);
    function handleLoadRating(id) {
        axios_1.default.get("/app/page/rating/".concat(id))
            .then(function (response) {
            if (response.status == 200) {
                if (response.data.amount) {
                    setRating(response.data.amount);
                }
                console.log(response.data);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }
    function handleUpdateRating(rating) {
        if (rating && gameId) {
            axios_1.default.post("/app/page/rating/".concat(gameId), {
                value: rating
            })
                .then(function (response) {
                if (response.status == 200) {
                    if (response.data.amount) {
                        setRating(response.data.amount);
                    }
                    console.log(response.data);
                }
            }).catch(function (error) {
                console.log("error", error);
            });
        }
    }
    return (react_1.default.createElement(react_1.Fragment, null, rating &&
        react_1.default.createElement("div", { className: "game-rating" },
            react_1.default.createElement("span", { style: { marginRight: "8px" } }, t("page.game.rating")),
            react_1.default.createElement(react_ratings_declarative_1.default, { rating: parseFloat(rating === null || rating === void 0 ? void 0 : rating.toFixed(2)), widgetDimensions: "24px", widgetSpacings: "4px", widgetHoverColors: "#FEBD5A", widgetEmptyColors: "rgba(34, 34, 34, 0.16)", widgetRatedColors: "#FEBD5A", changeRating: handleUpdateRating },
                react_1.default.createElement(react_ratings_declarative_1.default.Widget, null),
                react_1.default.createElement(react_ratings_declarative_1.default.Widget, null),
                react_1.default.createElement(react_ratings_declarative_1.default.Widget, null),
                react_1.default.createElement(react_ratings_declarative_1.default.Widget, null),
                react_1.default.createElement(react_ratings_declarative_1.default.Widget, null)),
            react_1.default.createElement("div", { className: "game-rating-value" }, rating === null || rating === void 0 ? void 0 :
                rating.toFixed(2),
                "/",
                MAX_RATING))));
};
exports.default = GameRating;
